// @ts-nocheck
import { useState, useEffect } from 'react';
import { getInspectionReports } from '../services/supabaseService';
import { useLocations } from './useLocations';

export const useMissingQuarterlyReports = () => {
  const [locationsWithoutReports, setLocationsWithoutReports] = useState<string[]>([]);
  const locations = useLocations();

  useEffect(() => {
    const fetchData = async () => {
      try {


        // Get current quarter and year
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentQuarter = Math.floor(now.getMonth() / 3) + 1;



        if (locations.length === 0) {

          return;
        }

        // Fetch all inspection reports
        const inspectionReports = await getInspectionReports();


        // Filter reports for the current quarter and year
        const currentQuarterReports = inspectionReports.filter(report => {
          const reportDate = new Date(report.date);
          const reportYear = reportDate.getFullYear();
          const reportQuarter = Math.floor(reportDate.getMonth() / 3) + 1;

          return reportYear === currentYear && reportQuarter === currentQuarter;
        });



        // Extract locations that have completed their quarterly inspection
        const completedLocations = new Set(currentQuarterReports.map(report => report.location));


        // Find locations without completed quarterly inspections
        const missingLocations = locations.filter(location => !completedLocations.has(location));


        setLocationsWithoutReports(missingLocations);
      } catch (error) {
        console.error('Error in useMissingQuarterlyReports:', error);
        setLocationsWithoutReports([]);
      }
    };

    if (locations.length > 0) {
      fetchData();
    }
  }, [locations]);

  return locationsWithoutReports;
};